export default "__VITE_ASSET__BiInvzUD__"